import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import * as React from 'react';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
import Tag from '../tag';
import Space from '../space';
import Search from '../search';
import Icon from '../icon';
import SchemeFilter from './scheme';
import ConditionFilter from './condition';

var Filter = function Filter(props) {
  var _context;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps,
      locale = _React$useContext.locale;

  var FilterLangMsg = locale.getCompLangMsg({
    componentName: 'Filter'
  }); // 属性需要合并一遍用户定义的默认属性

  var _getCompProps = getCompProps('Filter', userDefaultProps, props),
      style = _getCompProps.style,
      fields = _getCompProps.fields,
      schemes = _getCompProps.schemes,
      onChange = _getCompProps.onChange,
      className = _getCompProps.className,
      conditions = _getCompProps.conditions,
      onSchemeSave = _getCompProps.onSchemeSave,
      defaultTabKey = _getCompProps.defaultTabKey,
      onSpreadChange = _getCompProps.onSpreadChange,
      getSchemeSettingMenu = _getCompProps.getSchemeSettingMenu,
      customPrefixcls = _getCompProps.prefixCls; // className前缀


  var prefixCls = getPrefixCls(pkgPrefixCls, 'filter', customPrefixcls);

  var _React$useRef = React.useRef(props.value || props.defaultValue || {}),
      defaultValue = _React$useRef.current;

  var _React$useState = React.useState(defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  React.useEffect(function () {
    props.value && setValue(props.value);
  }, [props.value]);

  var _React$useState3 = React.useState(defaultTabKey),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      tab = _React$useState4[0],
      setTab = _React$useState4[1];

  var conditionValue = _Object$keys(value).length < 1 || _Object$keys(value).length === 1 && value.scheme ? defaultValue : value;

  var onConditionChange = function onConditionChange(nextValue, condition, option) {
    props.value === undefined && setValue(nextValue);
    onChange && onChange(nextValue, condition, option);
  };

  var onConditionRemove = function onConditionRemove(key, e) {
    e.preventDefault();

    if (key) {
      var nextValue = _extends({}, conditionValue);

      delete nextValue[key];
      onConditionChange(nextValue);
    }
  };

  var onSchemeSearch = function onSchemeSearch(scheme) {
    onConditionChange({
      scheme: scheme
    });
  };

  var _React$useState5 = React.useState(props.spread || props.defaultSpread),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      spread = _React$useState6[0],
      setSpread = _React$useState6[1];

  React.useEffect(function () {
    props.spread !== undefined && setSpread(props.spread);
  }, [props.spread]);

  var handleSwitchSpread = function handleSwitchSpread() {
    props.spread === undefined && setSpread(!spread);
    onSpreadChange && onSpreadChange(!spread);
  };

  var tabs = [{
    key: 'condition',
    name: FilterLangMsg.commonCondition
  }, {
    key: 'scheme',
    name: FilterLangMsg.schemeQuery
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, className),
    style: style
  }, /*#__PURE__*/React.createElement("header", {
    className: "".concat(prefixCls, "-header")
  }, /*#__PURE__*/React.createElement("h3", {
    className: "".concat(prefixCls, "-header-title")
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-header-condition")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-header-condition-label")
  }, FilterLangMsg.filterCondition), /*#__PURE__*/React.createElement(Space, {
    wrap: true,
    size: [4, 4]
  }, _mapInstanceProperty(_context = _Object$keys(value)).call(_context, function (conditionKey) {
    var name, options, required;

    if (conditionKey === 'scheme') {
      options = value[conditionKey].name;
      name = options && FilterLangMsg.scheme;
    } else {
      var _context2;

      var condition = _findInstanceProperty(conditions).call(conditions, function (_ref) {
        var key = _ref.key;
        return key === conditionKey;
      });

      var labels = _mapInstanceProperty(_context2 = value[conditionKey]).call(_context2, function (item) {
        var _context3;

        var filterOption = _findInstanceProperty(_context3 = condition.options).call(_context3, function (_ref2) {
          var optonValue = _ref2.value;
          return optonValue === item;
        }) || {};
        return filterOption.label || filterOption.value || item;
      });

      name = condition.label;
      options = labels.join(',');
      required = condition.required;
    }

    var conditionProps = {
      size: 'large',
      closable: !required,
      type: 'edit',
      onClose: onConditionRemove.bind(null, conditionKey)
    };
    return name && /*#__PURE__*/React.createElement(Tag, _extends({
      className: "".concat(prefixCls, "-header-condition-item"),
      key: conditionKey
    }, conditionProps), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-header-condition-item-text"),
      title: options
    }, name, "\uFF1A", options));
  }))), /*#__PURE__*/React.createElement(Search, _extends({
    className: "".concat(prefixCls, "-header-search"),
    type: "quick-search"
  }, props.search)), /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-header-handle"), {
      spread: spread
    }),
    onClick: handleSwitchSpread
  }, FilterLangMsg[spread ? 'packup' : 'spread'], _filterInstanceProperty(FilterLangMsg), " ", /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-body"), {
      spread: spread
    })
  }, /*#__PURE__*/React.createElement(Space, {
    size: 12,
    className: "".concat(prefixCls, "-body-tabs"),
    split: /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-body-tabs-split")
    })
  }, _mapInstanceProperty(tabs).call(tabs, function (_ref3) {
    var key = _ref3.key,
        name = _ref3.name;
    return /*#__PURE__*/React.createElement("span", {
      key: key,
      onClick: function onClick() {
        return setTab(key);
      },
      className: classNames("".concat(prefixCls, "-body-tabs-item"), {
        active: key === tab
      })
    }, name);
  })), /*#__PURE__*/React.createElement(ConditionFilter, _extends({}, {
    tab: tab,
    prefixCls: prefixCls,
    conditions: conditions,
    FilterLangMsg: FilterLangMsg,
    onConditionChange: onConditionChange,
    onConditionRemove: onConditionRemove,
    value: conditionValue
  })), /*#__PURE__*/React.createElement(SchemeFilter, _extends({}, {
    tab: tab,
    fields: fields,
    schemes: schemes,
    prefixCls: prefixCls,
    onSchemeSave: onSchemeSave,
    FilterLangMsg: FilterLangMsg,
    onSchemeSearch: onSchemeSearch,
    getSchemeSettingMenu: getSchemeSettingMenu,
    value: value
  }))));
};

Filter.displayName = 'Filter';
export default Filter;